/*
* Project: LegalPlace assistant
* File: src/components/contact_us.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showContactUs } from '../redux/actions/account_settings';
import { store } from '../globals';
import baseLink from '../baseLink';
import { raiseError, unraiseError } from '../errors/error';
import { _lp } from '../logic/wording';

export class _ContactUs extends Component {
  static closeModal() {
    store.dispatch(showContactUs(false));
  }

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      mail: '',
      subject: '',
      message: '',
      sent: false,
    };
    // init context for callbacks
    this.updateName = this.updateName.bind(this);
    this.updateMail = this.updateMail.bind(this);
    this.updateSubject = this.updateSubject.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.sendContact = this.sendContact.bind(this);
  }

  componentDidMount() {
    if (this.refs.contactus) {
      document.getElementById('contact-form').appendChild(this.refs.contactus);
      if (this.props.show_contact) {
        document.getElementById('contact-form').classList.add('lp-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
        document.body.style.overflow = 'hidden';
      } else {
        document.getElementById('contact-form').classList.remove('lp-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
        document.body.style.overflow = 'auto';
      }
    }
    // console.log("dddd " + this.props.show_contact)
    const a = document.getElementById('contact-form');
    document.getElementById('contact-form').addEventListener('click', (e) => { if (e.target === a) _ContactUs.closeModal(); });
  }

  componentWillUpdate(nextProps) {
    if (nextProps.show_contact && !this.props.show_contact) {
      if (this.state.sent) {
        this.state.sent = false;
        this.state.mail = '';
        this.state.name = '';
        this.state.subject = '';
        this.state.message = '';
      }
    }
  }

  componentDidUpdate() {
    // console.log(this.refs.contactus)
    if (this.refs.contactus) {
      // document.getElementById('contact-form').appendChild(this.refs.contactus);

      if (this.props.show_contact) {
        // console.log(this.refs.contactus)
        document.getElementById('contact-form').classList.add('lp-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'blur(5px)';
        document.body.style.overflow = 'hidden';
      } else {
        document.getElementById('contact-form').classList.remove('lp-modal');
        document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
        document.body.style.overflow = 'auto';
      }
    }
    // console.log("dddd " + this.props.show_contact)
  }

  componentWillUnmount() {
    document.getElementsByClassName('page-wrap')[0].style.filter = 'none';
    document.body.style.overflow = 'auto';
    document.getElementById('contact-form').classList.remove('lp-modal');
  }

  updateName(val) {
    this.setState({
      name: val.target.value,
    });
  }

  updateMail(val) {
    this.setState({
      mail: val.target.value,
    });
  }

  updateSubject(val) {
    this.setState({
      subject: val.target.value,
    });
  }

  updateMessage(val) {
    this.setState({
      message: val.target.value,
    });
  }

  sendContact(e) {
    e.preventDefault();
    const information = {
      name: this.state.name,
      email: this.state.mail,
      subject: this.state.subject,
      message: this.state.message,
    };
    const init = {
      method: 'POST',
      body: JSON.stringify(information),
    };
    const that = this;
    // managing errors
    let err0; let err1; let
      err2;
    err0 = false;
    err1 = false;
    err2 = false;

    if (this.state.name === '') {
      raiseError('contact-name', 9, _lp('Veuillez saisir votre nom complet'));
      err0 = true;
    } else {
      unraiseError('contact-name');
    }
    if (this.state.subject.length < 5) {
      raiseError('contact-subject', 9, _lp('Votre sujet dois contenir au moins 5 caractères'));
      err1 = true;
    } else unraiseError('contact-subject');
    if (this.state.message.length < 10) {
      raiseError('contact-message', 9, _lp('Votre message dois contenir au moins 10 caractères.'));
      err2 = true;
    } else unraiseError('contact-message');

    if (!err0 && !err1 && !err2) {
      fetch(`${baseLink}/data/contracts/contact_support`, init).then((response) => {
        response.json().then(() => {
          that.setState({
            sent: true,
          });
        }).catch((jsonError) => {
          raiseError('global', 2, _lp('Erreur de connexion serveur'));
        });
      }).catch((error) => {
        raiseError('global', 2, _lp('On pourait pas connecter au serveur'));
      });
    }
  }

  render() {
    return (
      <div ref="contactus" className="lpm-container">

        {this.props.show_contact
          && (
          <div>
            <div className="lpm-close icn-x" onClick={_ContactUs.closeModal} />
            <div className="lpm-title">{_lp("Besoin d'aide? Nous sommes là pour vous")}</div>
            <div className="lpm-content">

              {!this.state.sent && (
              <form acceptCharset="utf-8">
                <div className="container-fluid">
                  <div className="row">
                    <div className={`col-sm-6 form-group${typeof this.props.error_name === 'undefined' ? '' : ' error'}`}>
                      <label htmlFor="d1">{_lp('Votre nom')}</label>
                      <input type="text" placeholder={_lp('Nom complet')} className="form-control" id="cf-name" onChange={this.updateName} value={this.state.name} />
                      {(typeof this.props.error_name !== 'undefined') && <span className="help-block">{_lp(this.props.error_name.message)}</span>}
                    </div>
                    <div className="form-group col-sm-6">
                      <label htmlFor="d1">{_lp('Adresse email')}</label>
                      <input type="email" placeholder={_lp('Adresse email')} className="form-control" id="cf-email" onChange={this.updateMail} value={this.state.mail} />
                    </div>
                  </div>
                  <div className="row">
                    <div className={`form-group col-xs-12${typeof this.props.error_subject === 'undefined' ? '' : ' error'}`}>
                      <label htmlFor="d1">Sujet</label>
                      <input type="text" placeholder={_lp('Sujet')} className="form-control" id="cf-subject" onChange={this.updateSubject} value={this.state.subject} />
                      {(typeof this.props.error_subject !== 'undefined') && <span className="help-block">{this.props.error_subject.message}</span>}
                    </div>
                  </div>
                  <div className="row">
                    <div className={`form-group col-xs-12${typeof this.props.error_message === 'undefined' ? '' : ' error'}`}>
                      <label htmlFor="d1">{_lp('Votre message')}</label>
                      <textarea className="form-control" rows="3" id="cf-message" onChange={this.updateMessage} value={this.state.message} />
                      {(typeof this.props.error_message !== 'undefined') && <span className="help-block">{this.props.error_message.message}</span>}
                    </div>
                  </div>
                  {!this.state.sent && (
                  <div className="row">
                    <div className="col-xs-12 ">
                      <div className="form-group">
                        <button onClick={this.sendContact} className="btn btn-primary pull-right">{_lp('Envoyer')}</button>
                      </div>
                    </div>
                  </div>
                  )}
                </div>
              </form>
              )}


              {this.state.sent && (
              <div className="cf-success">
                <span className="icn-checkmark" />
                <h3>{_lp('Votre message a bien été envoyé')}</h3>
              </div>
              )}

            </div>
          </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  show_contact: state.account_settings.show_contact,
  error_name: state.errors.components['contact-name'],
  error_subject: state.errors.components['contact-subject'],
  error_message: state.errors.components['contact-message'],
});

const mapDispatchToProps = dispatch => ({
  closeContact: () => {
    dispatch(showContactUs(false));
  },
});

export const LpContactUs = connect(mapStateToProps, mapDispatchToProps)(_ContactUs);



// WEBPACK FOOTER //
// ./src/components/contact_us.js